import React from 'react';
import { SectionLabel } from './FeatureRow';
import { MONO } from '../../constants/fonts';

function PaymentTerms() {
  return (
    <section style={s.termsSection}>
      <div style={{ ...s.sectionInner, maxWidth: 680 }}>

        <SectionLabel>Payment</SectionLabel>
        <h2 style={{ ...s.sectionHeadline, fontSize: 'clamp(1.5rem, 4vw, 2rem)', marginBottom: 32 }}>
          Straightforward payment terms.
        </h2>

        <div className="care-grid" style={s.termsGrid}>
          <div style={s.termsCard}>
            <p style={s.termsCardTitle}>Websites</p>
            <div style={s.termsSplit}>
              <div style={s.termsPart}>
                <span style={{ ...s.termsPercent, color: '#818cf8' }}>50%</span>
                <span style={s.termsWhen}>Deposit</span>
              </div>
              <div style={s.termsDividerV} />
              <div style={s.termsPart}>
                <span style={{ ...s.termsPercent, color: '#34d399' }}>50%</span>
                <span style={s.termsWhen}>On launch</span>
              </div>
            </div>
          </div>
          <div style={s.termsCard}>
            <p style={s.termsCardTitle}>Apps</p>
            <div style={s.termsSplit}>
              <div style={s.termsPart}>
                <span style={{ ...s.termsPercent, color: '#818cf8' }}>40%</span>
                <span style={s.termsWhen}>Deposit</span>
              </div>
              <div style={s.termsDividerV} />
              <div style={s.termsPart}>
                <span style={{ ...s.termsPercent, color: '#f59e0b' }}>30%</span>
                <span style={s.termsWhen}>Build milestone</span>
              </div>
              <div style={s.termsDividerV} />
              <div style={s.termsPart}>
                <span style={{ ...s.termsPercent, color: '#34d399' }}>30%</span>
                <span style={s.termsWhen}>Before submission</span>
              </div>
            </div>
          </div>
        </div>

        <div style={s.termsNotes}>
          <p style={s.termsNote}>Nothing goes live and no source code is handed over until final payment clears.</p>
          <p style={s.termsNote}>Invoices payable within 14 days.</p>
          <p style={s.termsNote}>Third-party costs (domain, store accounts, premium plugins, stock imagery) are paid by you directly and are never in our fee.</p>
        </div>

      </div>
    </section>
  );
}

const s = {
  termsSection: {
    background: '#0f0f13',
    padding: 'clamp(56px, 8vw, 96px) 24px',
  },
  sectionInner: {
    maxWidth: 960,
    margin: '0 auto',
  },
  sectionHeadline: {
    fontSize: 'clamp(1.6rem, 5vw, 2.6rem)',
    fontWeight: 800,
    letterSpacing: '-0.03em',
    lineHeight: 1.15,
    color: '#f0f0f5',
    margin: '0 0 16px',
  },
  termsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 16,
    marginBottom: 28,
  },
  termsCard: {
    background: '#16161c',
    border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: 16,
    padding: '24px',
  },
  termsCardTitle: {
    fontFamily: MONO,
    fontSize: '0.7rem',
    fontWeight: 600,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: '#4a4f66',
    margin: '0 0 16px',
  },
  termsSplit: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 0,
  },
  termsPart: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
  },
  termsPercent: {
    fontFamily: MONO,
    fontSize: '1.6rem',
    fontWeight: 800,
    letterSpacing: '-0.02em',
    lineHeight: 1,
  },
  termsWhen: {
    fontSize: '0.7rem',
    color: '#4a4f66',
    textAlign: 'center',
  },
  termsDividerV: {
    width: 1,
    alignSelf: 'stretch',
    background: 'rgba(255,255,255,0.06)',
    flexShrink: 0,
  },
  termsNotes: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    padding: '20px',
    background: 'rgba(255,255,255,0.02)',
    border: '1px solid rgba(255,255,255,0.05)',
    borderRadius: 12,
  },
  termsNote: {
    fontSize: '0.82rem',
    color: '#4a4f66',
    lineHeight: 1.6,
    margin: 0,
    paddingLeft: 12,
    borderLeft: '2px solid rgba(255,255,255,0.06)',
  },
};

export default PaymentTerms;
